var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCheckSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_check_small",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "bounding_box",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7702146,4.22978542 C10.9784378,4.43800862 10.9784378,4.77560513 10.7702146,4.98382834 L6.24595708,9.50808583 C6.17654935,9.57749357 6.0927668,9.62376539 6.00419265,9.6469013 L5.91437624,9.66232524 L5.91437624,9.66232524 L5.82349502,9.66232524 C5.70255668,9.65204261 5.58445781,9.60062948 5.49191417,9.50808583 L3.22978542,7.24595708 C3.02156222,7.03773388 3.02156222,6.70013737 3.22978542,6.49191417 C3.43800862,6.28369097 3.77560513,6.28369097 3.98382834,6.49191417 L5.868,8.377 L10.0161717,4.22978542 C10.2243949,4.02156222 10.5619914,4.02156222 10.7702146,4.22978542 Z",
    id: "shape_checkmark",
    fill: "#2D72FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCheckSmall);
export default __webpack_public_path__ + "static/media/icn_check_small.20a41f6f5ba75bf4f424b730e063dbf7.svg";
export { ForwardRef as ReactComponent };